import React, { useState, useEffect } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import {
  tokenIsValid,
  getToken,
  calculateDateRange,
  changeDateFormatToMMDDYYYY,
  changeDateFormatToYYYYMMDD,
  changeDateFormatToYYYYMMDDwithDash,
  checkIsReschedule,
  //   checkVenue,
  getSubPlaceShortName,
  isShuttleBus,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';
import './SelectDepartureHeader.css';
import { useSearchParams } from 'react-router-dom';
import { AutocompleteInput } from './AutocompleteInput';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export const SelectDepartureHeader = ({
  subplace_data,
  title,

  depart_data,
  destination_data,

  date_depart,
  date_return,
  passenger,
  edit_search,
}) => {
  // console.log("==========================")

  // console.log('SelectDepartureHeader.js');
  // console.dir(JSON.stringify(depart_data));
  // console.dir(destination_data);

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [searchParams, setSearchParams] = useSearchParams();
  const request_id = searchParams.get('request_id') ?? '';

  // const checkReschedule = checkIsReschedule();
  let oldcartguid = null;
  let reschedule_departDate = null;
  let reschedule_returnDate = null;
  let reschedule_passenger = null;
  let reschedule_reschedule = null;
  let reschedule_passengerDetails = null;

  let origin_data = sessionStorageGetItem('Origin_data');
  // if (origin_data != null) {
  // 	origin_data = JSON.parse(origin_data);
  // console.log(origin_data)
  // if (checkReschedule) {
  // 	oldcartguid = origin_data.OldCartGuid;
  // 	reschedule_departDate = origin_data.DepartDate;
  // 	reschedule_returnDate = origin_data.ReturnDate;
  // 	reschedule_passenger = origin_data.Passenger;
  // 	reschedule_reschedule = origin_data.Reschedule;
  // 	reschedule_passengerDetails = origin_data.PassengerDetails;
  // }
  // }

  const [new_depart, setDepart] = useState({
    label: depart_data?.placename,
    value: depart_data?.placeuniqueshortname,
  });
  const [new_destination, setDestination] = useState({
    label: destination_data?.placename,
    value: destination_data?.placeuniqueshortname,
  });
  const [new_depart_date, setDepartDate] = useState(date_depart);
  const [new_return_date, setReturnDate] = useState(date_return);
  const [new_passenger, setPassenger] = useState(passenger);
  // console.log(depart)
  // console.log(new_destination)
  // console.log(new_depart_date)
  // console.log(new_return_date)
  // console.log(new_passenger)
  const [oneWayTrip, setOneWayTrip] = useState(true); //true = is one way trip; false = round trip
  const [editMode, setEditMode] = useState(false);

  const predefinedOrigins = [
    { label: 'Johor (All Locations)', value: 'johor' },
    { label: 'Singapore (All Locations)', value: 'singapore' },
    { label: 'Kuala Lumpur (All Locations)', value: 'kualalumpur' },
    { label: 'Malacca (All Locations)', value: 'malacca' },
    { label: 'Selangor (All Locations)', value: 'selangor' },
  ].sort((a, b) => a.label.localeCompare(b.label));
  const predefinedDestinations = [
    { label: 'Johor (All Locations)', value: 'johor' },
    { label: 'Singapore (All Locations)', value: 'singapore' },
    { label: 'Kuala Lumpur (All Locations)', value: 'kualalumpur' },
    { label: 'Malacca (All Locations)', value: 'malacca' },
    { label: 'Selangor (All Locations)', value: 'selangor' },
  ].sort((a, b) => a.label.localeCompare(b.label));

  const [origins, setOrigins] = useState(predefinedOrigins);
  const [destinations, setDestinations] = useState(predefinedDestinations);

  // const [availableDestination, setAvailableDestination] = useState(null);
  // console.log(availableDestination)

  useEffect(() => {
    // let selected_subplace_id = 32;

    // if (sessionStorageGetItem('Origin_data') != null) {
    // 	const origin_data = JSON.parse(sessionStorageGetItem('Origin_data'));
    // 	selected_subplace_id = origin_data.subplaceid;
    // console.log(selected_subplace_id)
    // console.log(origin_data)
    // }

    // const getAvailableDestination = async () => {
    // 	try {
    // 		const response = await fetch(
    // 			`${SERVER_URL}/me/get/subplaces/origin/${selected_subplace_id}`,
    // 			{
    // 				headers: {
    // 					Authorization: getToken(),
    // 				},
    // 			}
    // 		);
    // 		if (!response.ok) {
    // 			throw new Error(
    // 				`This is an HTTP error: The status is ${response.status}`
    // 			);
    // 		}
    // 		let actualData = await response.json();
    // 		// console.log(actualData)
    // 		setAvailableDestination(actualData);
    // 	} catch (err) {
    // 		setAvailableDestination(null);
    // 	}
    // };
    tokenIsValid();
    // getAvailableDestination();
  }, [new_depart]);

  const setOriginData = (selected_place) => {
    sessionStorage.removeItem('Origin_data');

    for (let i = 0; i < subplace_data.length; i++) {
      if (selected_place === subplace_data[i].placeuniqueshortname) {
        sessionStorageSetItem(
          'Origin_data',
          JSON.stringify({
            placeid: subplace_data[i].placeid,
            placename: subplace_data[i].placename,
            placedisplayname: subplace_data[i].placedisplayname,
            placeuniqueshortname: subplace_data[i].placeuniqueshortname,

            subplaceid: null,
            subplacename: null,
            subplaceuniqueshortname: null,
            subplacedisplayname1: null,
          }),
        );
      }

      for (let j = 0; j < subplace_data[i].subplaces.length; j++) {
        // console.log(
        //   subplace_data[i].subplaces[j].subplaceuniqueshortname,
        //   selected_place
        // );
        if (
          subplace_data[i].subplaces[j].subplaceuniqueshortname ===
          selected_place
        ) {
          // setDepart(subplace_data[i].subplaces[j].subplaceuniqueshortname);
          sessionStorageSetItem(
            'Origin_data',
            JSON.stringify({
              placeid: subplace_data[i].placeid,
              placename: subplace_data[i].placename,
              placedisplayname: subplace_data[i].placedisplayname,
              placeuniqueshortname: subplace_data[i].placeuniqueshortname,

              subplaceid: subplace_data[i].subplaces[j].subplaceid,
              subplacename: subplace_data[i].subplaces[j].subplacename,
              subplaceuniqueshortname:
                subplace_data[i].subplaces[j].subplaceuniqueshortname,
              subplacedisplayname1:
                subplace_data[i].subplaces[j].subplacedisplayname1,
            }),
          );
        }
      }
    }
  };

  const setDestinationData = (selected_place) => {
    sessionStorage.removeItem('Destination_data');
    for (let i = 0; i < subplace_data.length; i++) {
      if (selected_place === subplace_data[i].placeuniqueshortname) {
        // setDestination(selected_place);

        sessionStorageSetItem(
          'Destination_data',
          JSON.stringify({
            placeid: subplace_data[i].placeid,
            placename: subplace_data[i].placename,
            placedisplayname: subplace_data[i].placedisplayname,
            placeuniqueshortname: subplace_data[i].placeuniqueshortname,

            subplaceid: null,
            subplacename: null,
            subplaceuniqueshortname: null,
            subplacedisplayname1: null,
          }),
        );
      }

      for (let j = 0; j < subplace_data[i].subplaces.length; j++) {
        if (
          subplace_data[i].subplaces[j].subplaceuniqueshortname ===
          selected_place
        ) {
          // setDestination(subplace_data[i].subplaces[j].subplaceuniqueshortname);
          sessionStorageSetItem(
            'Destination_data',
            JSON.stringify({
              placeid: subplace_data[i].placeid,
              placename: subplace_data[i].placename,
              placedisplayname: subplace_data[i].placedisplayname,
              placeuniqueshortname: subplace_data[i].placeuniqueshortname,

              subplaceid: subplace_data[i].subplaces[j].subplaceid,
              subplacename: subplace_data[i].subplaces[j].subplacename,
              subplaceuniqueshortname:
                subplace_data[i].subplaces[j].subplaceuniqueshortname,
              subplacedisplayname1:
                subplace_data[i].subplaces[j].subplacedisplayname1,
            }),
          );
        }
      }
    }
  };

  function swapVenue() {
    if (new_depart.value !== '' && new_destination.value !== '') {
      var ov = document.getElementById('origin_venue');
      var dv = document.getElementById('destination_venue');
      var tempOV = ov.value;
      var tempDV = dv.value;
      ov.value = tempDV;
      dv.value = tempOV;
      setOriginData(ov.value);
      setDestinationData(dv.value);
    }
    // console.log(depart)
    // console.log(destination)
  }

  // console.log(oneWayTrip);
  // console.log(subplace_data);
  const converted_depart_date = new Intl.DateTimeFormat('en', {
    month: 'short',
    day: '2-digit',
  }).format(Date.parse(date_depart));

  // console.log(changeDateFormatToMMDDYYYY(date_depart))
  // console.log(date_depart)
  // console.log(date_return)
  const editDepartDate = changeDateFormatToMMDDYYYY(date_depart);
  // console.log(editDepartDate)
  const editReturnDate = changeDateFormatToMMDDYYYY(date_return);

  // console.log(editReturnDate)
  const checkOneWay = date_return == 'null' ? true : false;
  let converted_return_date = null;
  // console.log(checkOneWay)

  function handleCallbackDepart(start) {
    // console.log(changeDateFormatToYYYYMMDD(start._d));
    setDepartDate(changeDateFormatToYYYYMMDD(start._d));
  }

  function handleCallbackReturn(end) {
    // console.log(end);
    setReturnDate(changeDateFormatToYYYYMMDD(end._d));
  }
  const handleCancel = (event, picker) => {
    picker.element.val('');
    setReturnDate(null);
  };
  const handleApply = (event, picker) => {
    picker.element.val(picker.startDate.format('MM/DD/YYYY'));
  };
  // console.log(parseInt('07'))
  function checkValidation() {
    // console.log(changeDateFormatToYYYYMMDDwithDash(new_depart_date))
    // console.log(changeDateFormatToYYYYMMDDwithDash(new_return_date))
    if (
      new_depart === '' ||
      new_destination === '' ||
      new_depart_date === '' ||
      new_passenger === ''
    ) {
      if (new_passenger && new_passenger) {
        if (new_depart === '' && new_destination === '') {
          alert('Location no found.');
          return;
        }
      }

      alert('Please Key In all data');
      return false;
    } else {
      // console.log(new_return_date)
      if (new_return_date !== '' && new_return_date !== null) {
        if (
          changeDateFormatToYYYYMMDDwithDash(new_return_date) <
          changeDateFormatToYYYYMMDDwithDash(new_depart_date)
        ) {
          alert(
            'Selected date cannot be earlier than today or return date cannot be earlier than depart date',
          );
        } else if (new_passenger < 1 || new_passenger > 8) {
          alert('Passenger should not less than 1 or more than 8!');
          // } else if (checkVenue() == false) {
          //   alert('Selected Origin or Destination is invalid!');
        } else return true;
      } else {
        // else if (calculateDateRange(new_depart_date, new_return_date) > 6) {
        //     alert("Return date cannot be more than 7 days");
        // }
        if (new_passenger < 1 || new_passenger > 8) {
          alert('Passenger should not less than 1 or more than 8!');
          // } else if (checkVenue() == false) {
          //   alert('Selected Origin or Destination is invalid!');
        } else return true;
      }
    }
    return false;
  }

  function editSearch() {
    const edit_validation = checkValidation();
    if (edit_validation) {
      setEditMode(false);

      // if (checkReschedule == false) {
      window.location.href = `/pickDepart?depart=${new_depart.value}&destination=${new_destination.value}&depart_date=${new_depart_date}&return_date=${new_return_date}&passenger=${new_passenger}&request_id=${request_id}`;
      // } else {
      // 	window.location.href = '/pickDepart';
      // }
    }
  }

  function clearDestination() {
    setDestinationData('');
    var dv = document.getElementById('destination_venue');
    dv.value = '';
  }

  function getHref() {
    return `/pickDepart?depart=${new_depart}&destination=${new_destination}&depart_date=${new_depart_date}&return_date=${new_return_date}&passenger=${new_passenger}`;
  }

  function filterLocations(all, allowedValues) {
    return all.filter((item) => allowedValues.includes(item.value));
  }

  function updatePredefinedLocations(value, direction) {
    const allowedCombos = {
      kualalumpur: ['johor', 'singapore'],
      malacca: ['singapore'],
      johor: ['johor', 'selangor', 'kualalumpur'],
      selangor: ['singapore', 'johor'],
      singapore: ['malacca', 'kualalumpur', 'selangor'],
    };

    if (!value) {
      setOrigins(predefinedOrigins);
      setDestinations(predefinedDestinations);
      return;
    }

    if (direction === 'origin') {
      const allowedDestinations = allowedCombos[value] ?? [];

      setDestinations(
        filterLocations(predefinedDestinations, allowedDestinations),
      );
    } else {
      const allowedOrigins = Object.entries(allowedCombos)
        .filter(([_, destinations]) => destinations.includes(value))
        .map(([origin]) => origin);

      setOrigins(filterLocations(predefinedOrigins, allowedOrigins));
    }
  }

  if (!checkOneWay) {
    converted_return_date = new Intl.DateTimeFormat('en', {
      month: 'short',
      day: '2-digit',
    }).format(Date.parse(date_return));
  }
  // console.log(converted_return_date)

  return (
    <>
      <div className='departure-header-container'>
        <Container>
          {!editMode ? (
            <Row>
              <Col xs={5} sm={5} lg={2}>
                {depart_data?.placename &&
                depart_data.placename.trim() !== '' &&
                depart_data?.subplacedisplayname == null ? (
                  <>
                    <h6>Origin</h6>
                    <h5>
                      {depart_data?.subplacedisplayname1 ||
                        depart_data?.placedisplayname}
                    </h5>
                  </>
                ) : (
                  <>
                    <h6>{depart_data?.placename || 'Unknown Origin'}</h6>
                    <h5>
                      {depart_data?.subplacedisplayname ||
                        depart_data?.placename ||
                        '—'}
                    </h5>
                  </>
                )}
              </Col>
              <Col xs={2} sm={2} lg={1} className='m-auto'>
                <img src='images/vector.png' />
              </Col>
              <Col xs={5} sm={5} lg={2}>
                {destination_data?.placename &&
                destination_data.placename.trim() !== '' &&
                destination_data?.subplacedisplayname == null ? (
                  <>
                    <h6>Destination</h6>
                    <h5>
                      {destination_data.subplacedisplayname1 ||
                        destination_data.placedisplayname}
                    </h5>
                  </>
                ) : (
                  <>
                    <h6>{destination_data?.placename || 'Unknown Origin'}</h6>
                    <h5>
                      {destination_data?.subplacedisplayname ||
                        destination_data?.placename ||
                        '—'}
                    </h5>
                  </>
                )}
              </Col>
              <hr />
              <Col xs={5} sm={5} lg={2} className='header_border-left'>
                <h6>Passenger</h6>
                <h5>{passenger} Pax</h5>
              </Col>
              <Col xs={2} sm={2} lg={1} className=''></Col>
              <Col xs={5} sm={5} lg={2}>
                <h6>Date</h6>
                {date_return == null ? (
                  <h5>{moment(new_depart_date).format('DD/MM/YYYY')}</h5>
                ) : (
                  <h5>
                    {moment(new_depart_date).format('DD/MM/YYYY')}{' '}
                    {new_return_date === 'null' ? '' : '-'}{' '}
                    {new_return_date !== 'null'
                      ? moment(new_return_date).format('DD/MM/YYYY')
                      : ''}
                  </h5>
                )}
              </Col>
              <Col xs={12} sm={12} lg={2} className='m-auto center'>
                <a onClick={() => setEditMode(true)}>
                  <h3 className='m-auto float-right'>
                    {edit_search}&nbsp;
                    <span className='fas fa-light fa-caret-down icon-blue'></span>
                  </h3>
                </a>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={12} sm={12} lg={2}>
                <h6>Origin</h6>

                <AutocompleteInput
                  id='origin_venue'
                  name='origin_venue'
                  placeholder='Type stop name'
                  label=''
                  predefinedOptions={origins}
                  apiEndpoint={`${SERVER_URL}/me/get/subplaces/search`}
                  getToken={getToken}
                  defaultValue={{
                    label:
                      depart_data?.subplacedisplayname ||
                      depart_data?.placedisplayname,
                    value:
                      depart_data?.subplaceuniqueshortname ||
                      depart_data?.placeuniqueshortname,
                  }}
                  onSelect={(value, label, parent) => {
                    setDepart({ label, value });
                    setOriginData(value);
                    updatePredefinedLocations(parent, 'origin');
                    // clearDestination();
                  }}
                />

                {/* <select
									name='origin_venue'
									id='origin_venue'
									className='edit_venue'
									defaultValue={depart.subplaceuniqueshortname}
									onChange={(event) => {
										setOriginData(event.target.value);
										clearDestination();
									}}
								>
									<option value=''>City</option>
									{subplace_data &&
										subplace_data
											.filter((_) => _.subplaces.filter((c) => c).length > 0)
											.filter((s) => s)
											.map(
												(
													{ placename, subplaces, subplacedisplayname1 },
													index
												) => (
													<optgroup label={placename}>
														{subplaces &&
															subplaces
																.filter((s) => s)
																.map(
																	(
																		{
																			subplacename,
																			subplaceuniqueshortname,
																			subplacedisplayname1,
																		},
																		index
																	) => (
																		<option value={subplaceuniqueshortname}>
																			{subplacedisplayname1}{' '}

																		</option>
																	)
																)}
													</optgroup>
												)
											)}
								</select> */}
              </Col>
              <Col lg={1} className='none-992 m-auto'>
                <img
                  className='vectorSwap'
                  onClick={swapVenue}
                  src='images/vector.png'
                />
              </Col>
              <Col xs={12} sm={12} lg={2}>
                <h6>Destination</h6>
                <AutocompleteInput
                  id='destination_venue'
                  name='destination_venue'
                  placeholder='Type stop name'
                  label=''
                  predefinedOptions={destinations}
                  apiEndpoint={`${SERVER_URL}/me/get/subplaces/search`}
                  getToken={getToken}
                  defaultValue={{
                    label:
                      destination_data?.subplacedisplayname ||
                      destination_data?.placedisplayname,
                    value:
                      destination_data?.subplaceuniqueshortname ||
                      destination_data?.placeuniqueshortname,
                  }}
                  onSelect={(value, label, parent) => {
                    setDestination({ label, value });
                    setDestinationData(value);
                    updatePredefinedLocations(parent, 'destination');
                  }}
                />

                {/* <select
									name='destination_venue'
									id='destination_venue'
									className='edit_venue'
									defaultValue={destination.subplaceuniqueshortname}
									onChange={(event) => setDestinationData(event.target.value)}
								>
									<option value=''>City</option>
									{availableDestination &&
										availableDestination
											.filter((_) => _.subplaces.filter((c) => c).length > 0)
											.map(({ placename, subplaces }, index) => (
												<optgroup label={placename}>
													{subplaces &&
														subplaces.map(
															(
																{ subplacename, subplaceuniqueshortname },
																index
															) => (
																<option value={subplaceuniqueshortname}>
																	{subplacename}
																</option>
															)
														)}
												</optgroup>
											))}
								</select> */}
              </Col>
              <Col xs={12} sm={12} lg={2} className='header_border-left'>
                <h6>Passenger</h6>
                <input
                  className=''
                  type='number'
                  min='1'
                  max='8'
                  name='passenger'
                  defaultValue={passenger}
                  onChange={(event) => setPassenger(event.target.value)}
                  required
                  // disabled={checkReschedule == true ? true : false}
                />
              </Col>
              <Col xs={12} sm={12} lg={2}>
                <h6>Depart</h6>
                <DatePicker
                  minDate={new Date()}
                  selected={
                    new_depart_date && !isNaN(Date.parse(new_depart_date))
                      ? new Date(new_depart_date)
                      : new Date()
                  }
                  onChange={(e) =>
                    e
                      ? setDepartDate(moment(e).format('YYYY-MM-DD'))
                      : new Date()
                  }
                  dateFormat='dd/MM/yyyy'
                  id='depart-date'
                />
              </Col>
              <Col xs={12} sm={12} lg={2}>
                <h6>Return (Optional)</h6>

                <DatePicker
                  minDate={
                    new_depart_date ? new Date(new_depart_date) : new Date()
                  }
                  selected={
                    new_return_date && !isNaN(Date.parse(new_return_date))
                      ? new Date(new_return_date)
                      : undefined
                  }
                  onChange={(e) => {
                    e
                      ? setReturnDate(moment(e).format('YYYY-MM-DD'))
                      : setReturnDate('null');
                  }}
                  dateFormat='dd/MM/yyyy'
                  isClearable={true}
                  placeholderText='Optional'
                  id='return-date'
                />
              </Col>
              <Col xs={12} sm={12} lg={1} className='m-auto center'>
                <button className='search_button' onClick={editSearch}>
                  Search
                </button>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};
